<script lang="ts">
  import { fade } from 'svelte/transition';
  import { lockBodyScroll, unlockBodyScroll } from '@athena-lib/scroll';
  import clsx from 'clsx';
  import type { OverlayProps } from './types';

  const {
    isOpen,
    onClose,
    children,
    label,
    lockBodyScrollDeviceSize,
    overlayClass,
    lockScrolling = true,
  }: OverlayProps = $props();

  $effect(() => {
    if (!isOpen) {
      return;
    }

    const unbind = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', unbind);

    return () => {
      window.removeEventListener('keydown', unbind);
    };
  });

  $effect(() => {
    if (!lockScrolling || !isOpen) {
      return;
    }
    lockBodyScroll(lockBodyScrollDeviceSize);
    return () => unlockBodyScroll(lockBodyScrollDeviceSize);
  });
</script>

{#if isOpen}
  <div role="dialog" aria-label={label} class={clsx('absolute z-20', overlayClass)}>
    <div
      class="fixed bottom-0 left-0 right-0 top-0 bg-st-black opacity-40"
      transition:fade={{ duration: 50 }}
      onclick={() => onClose()}
      aria-hidden="true"
    ></div>
    {@render children()}
  </div>
{/if}
